function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { traverseBreakpoints } from "./traverseBreakpoints.js";
function getSelfSpacingVar(axis) {
    return "--Grid-".concat(axis, "Spacing");
}
function getParentSpacingVar(axis) {
    return "--Grid-parent-".concat(axis, "Spacing");
}
var selfColumnsVar = '--Grid-columns';
var parentColumnsVar = '--Grid-parent-columns';
export var generateGridSizeStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var styles = {};
    traverseBreakpoints(theme.breakpoints, ownerState.size, function(appendStyle, value) {
        var style = {};
        if (value === 'grow') {
            style = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%'
            };
        }
        if (value === 'auto') {
            style = {
                flexBasis: 'auto',
                flexGrow: 0,
                flexShrink: 0,
                maxWidth: 'none',
                width: 'auto'
            };
        }
        if (typeof value === 'number') {
            style = {
                flexGrow: 0,
                flexBasis: 'auto',
                width: "calc(100% * ".concat(value, " / var(").concat(parentColumnsVar, ") - (var(").concat(parentColumnsVar, ") - ").concat(value, ") * (var(").concat(getParentSpacingVar('column'), ") / var(").concat(parentColumnsVar, ")))")
            };
        }
        appendStyle(styles, style);
    });
    return styles;
};
export var generateGridOffsetStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var styles = {};
    traverseBreakpoints(theme.breakpoints, ownerState.offset, function(appendStyle, value) {
        var style = {};
        if (value === 'auto') {
            style = {
                marginLeft: 'auto'
            };
        }
        if (typeof value === 'number') {
            style = {
                marginLeft: value === 0 ? '0px' : "calc(100% * ".concat(value, " / var(").concat(parentColumnsVar, ") + var(").concat(getParentSpacingVar('column'), ") * ").concat(value, " / var(").concat(parentColumnsVar, "))")
            };
        }
        appendStyle(styles, style);
    });
    return styles;
};
export var generateGridColumnsStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    if (!ownerState.container) {
        return {};
    }
    var styles = _define_property({}, selfColumnsVar, 12);
    traverseBreakpoints(theme.breakpoints, ownerState.columns, function(appendStyle, value) {
        var columns = value !== null && value !== void 0 ? value : 12;
        var _obj;
        appendStyle(styles, (_obj = {}, _define_property(_obj, selfColumnsVar, columns), _define_property(_obj, '> *', _define_property({}, parentColumnsVar, columns)), _obj));
    });
    return styles;
};
export var generateGridRowSpacingStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    if (!ownerState.container) {
        return {};
    }
    var styles = {};
    traverseBreakpoints(theme.breakpoints, ownerState.rowSpacing, function(appendStyle, value) {
        var _theme_spacing;
        var spacing = typeof value === 'string' ? value : (_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.call(theme, value);
        var _obj;
        appendStyle(styles, (_obj = {}, _define_property(_obj, getSelfSpacingVar('row'), spacing), _define_property(_obj, '> *', _define_property({}, getParentSpacingVar('row'), spacing)), _obj));
    });
    return styles;
};
export var generateGridColumnSpacingStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    if (!ownerState.container) {
        return {};
    }
    var styles = {};
    traverseBreakpoints(theme.breakpoints, ownerState.columnSpacing, function(appendStyle, value) {
        var _theme_spacing;
        var spacing = typeof value === 'string' ? value : (_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.call(theme, value);
        var _obj;
        appendStyle(styles, (_obj = {}, _define_property(_obj, getSelfSpacingVar('column'), spacing), _define_property(_obj, '> *', _define_property({}, getParentSpacingVar('column'), spacing)), _obj));
    });
    return styles;
};
export var generateGridDirectionStyles = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    if (!ownerState.container) {
        return {};
    }
    var styles = {};
    traverseBreakpoints(theme.breakpoints, ownerState.direction, function(appendStyle, value) {
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
export var generateGridStyles = function(param) {
    var ownerState = param.ownerState;
    return _object_spread({
        minWidth: 0,
        boxSizing: 'border-box'
    }, ownerState.container && _object_spread_props(_object_spread({
        display: 'flex',
        flexWrap: 'wrap'
    }, ownerState.wrap && ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), {
        gap: "var(".concat(getSelfSpacingVar('row'), ") var(").concat(getSelfSpacingVar('column'), ")")
    }));
};
export var generateSizeClassNames = function(size) {
    var classNames = [];
    Object.entries(size).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (value !== false && value !== undefined) {
            classNames.push("grid-".concat(key, "-").concat(String(value)));
        }
    });
    return classNames;
};
export var generateSpacingClassNames = function(spacing) {
    var smallestBreakpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'xs';
    var isValidSpacing = function isValidSpacing(val) {
        if (val === undefined) {
            return false;
        }
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    };
    if (isValidSpacing(spacing)) {
        return [
            "spacing-".concat(smallestBreakpoint, "-").concat(String(spacing))
        ];
    }
    if ((typeof spacing === "undefined" ? "undefined" : _type_of(spacing)) === 'object' && !Array.isArray(spacing)) {
        var classNames = [];
        Object.entries(spacing).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (isValidSpacing(value)) {
                classNames.push("spacing-".concat(key, "-").concat(String(value)));
            }
        });
        return classNames;
    }
    return [];
};
export var generateDirectionClasses = function(direction) {
    if (direction === undefined) {
        return [];
    }
    if ((typeof direction === "undefined" ? "undefined" : _type_of(direction)) === 'object') {
        return Object.entries(direction).map(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            return "direction-".concat(key, "-").concat(value);
        });
    }
    return [
        "direction-xs-".concat(String(direction))
    ];
};
